// extracted by mini-css-extract-plugin
export default {"attachmentCellRoot":"attachmentCellRoot--xd96Y"};